import styled from '@emotion/styled';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {EUndecoratedButton} from '@ELib/components/EButtons';
import {Language} from '@ELib/utilities/languages';

const languages = [Language.English, Language.German];

export const AuthWorkflowHeader = ({
  changeLanguage,
  language,
}: {
  changeLanguage: (lang: Language) => void;
  language: string;
}): React.ReactElement => {
  const {t} = useTranslation('lib');

  return (
    <Wrapper>
      {languages.map((lang) => (
        <EUndecoratedButton
          key={lang}
          active={language === lang}
          textColor
          onClick={() => changeLanguage(lang)}
        >
          {t(`languages.${lang}`)}
        </EUndecoratedButton>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: var(--gutter);
  margin-bottom: var(--gutter-small);
`;
